import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub2_2/57b33feeaca8c31d554f9da19fdf0e6f_water__c1_w280_h397.png'
import _imports_1 from '@/assets/thum_img/kp708b/sub2_2/62af3007b835cd24d68869e39e388380_water__c1_w280_h397.png'
import _imports_2 from '@/assets/img/testing/tec.png'


const _hoisted_1 = { class: "sub04_wrap" }

import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'TOCC_Items',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Testing.Tocc.Tocc_e.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[2] || (_cache[2] = _createElementVNode("h1", null, "TOCC창의역량검사_아동용(고)", -1))
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Testing.Tocc.Tocc_h.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "TOCC창의역량검사_청소년용", -1))
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Testing.Tocc.Tec.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[8] || (_cache[8] = _createElementVNode("h1", null, "TEC창의역량검사_전문가용", -1))
      ])
    ])
  ]))
}
}

})